import { PartnerType } from '@retailer-platform/dashboard/utils'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'

export const instacartDeveloperPlatformAccessControl: DomainAccessControlConfig = {
  partnerTypes: PartnerType.IDP,
}
